import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";

export default function HostingAndCloudServices() {
  return (
    <div className="Hosting-And-Cloud-Services pt-[160px] sm:pt-0">
      <Helmet>
        <title>Hosting & Cloud Services | Mean3</title>
        <meta
        name="description"
        content="Cloud hosting is the ability for a site to be stored on various servers. It will help you ensure the right resources are pulled from various places, enabling the ability to be a scalable, reliable, and flexible option for hosting."
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
    </div>
  );
}
